// import {
//   FETCH_ATTENDANCE_REQUEST,
//   FETCH_ATTENDANCE_SUCCESS,
//   FETCH_ATTENDANCE_FAILURE,

//   FETCH_PAPERS_REQUEST,
//   FETCH_PAPERS_SUCCESS,
//   FETCH_PAPERS_FAILURE,

//   FETCH_PAPER_SUMMARY_REQUEST,
//   FETCH_PAPER_SUMMARY_SUCCESS,
//   FETCH_PAPER_SUMMARY_FAILURE,

//   FETCH_SEM_SUMMARY_REQUEST,
//   FETCH_SEM_SUMMARY_SUCCESS,
//   FETCH_SEM_SUMMARY_FAILURE,
// } from "../actions/attendanceActions";

// const initialState = {
//   attendance: [],
//   papers: [],
//   paperSummary: null, // Changed from [] to null
//   semesterSummary: null, // Changed from [] to null
//   pagination: {
//     currentPage: 1,
//     totalPages: 1,
//     totalRecords: 0,
//     limit: 10,
//   },
//   loading: false,
//   error: null,
// };

// const attendanceReducer = (state = initialState, action) => {
//   switch (action.type) {
//     /* ================= ATTENDANCE ================= */
//     case FETCH_ATTENDANCE_REQUEST:
//       return { ...state, loading: true, error: null };

//     case FETCH_ATTENDANCE_SUCCESS:
//       return {
//         ...state,
//         loading: false,
//         attendance: action.payload.attendance,
//         pagination: action.payload.pagination,
//       };

//     case FETCH_ATTENDANCE_FAILURE:
//       return { ...state, loading: false, error: action.payload };

//     /* ================= PAPERS ================= */
//     case FETCH_PAPERS_REQUEST:
//       return { ...state, loading: true, error: null };

//     case FETCH_PAPERS_SUCCESS:
//       return {
//         ...state,
//         loading: false,
//         papers: action.payload,
//       };

//     case FETCH_PAPERS_FAILURE:
//       return { ...state, loading: false, error: action.payload };

//     /* ================= PAPER SUMMARY ================= */
//     case FETCH_PAPER_SUMMARY_REQUEST:
//       return { ...state, loading: true, error: null };

//     case FETCH_PAPER_SUMMARY_SUCCESS:
//       return {
//         ...state,
//         loading: false,
//         paperSummary: action.payload, // Store entire payload
//       };

//     case FETCH_PAPER_SUMMARY_FAILURE:
//       return { ...state, loading: false, error: action.payload };

//     /* ================= SEMESTER SUMMARY ================= */
//     case FETCH_SEM_SUMMARY_REQUEST:
//       return { ...state, loading: true, error: null };

//     case FETCH_SEM_SUMMARY_SUCCESS:
//       return {
//         ...state,
//         loading: false,
//         semesterSummary: action.payload, // Store entire payload
//       };

//     case FETCH_SEM_SUMMARY_FAILURE:
//       return { ...state, loading: false, error: action.payload };

//     default:
//       return state;
//   }
// };

// export default attendanceReducer;

import {
  FETCH_ATTENDANCE_REQUEST,
  FETCH_ATTENDANCE_SUCCESS,
  FETCH_ATTENDANCE_FAILURE,
  FETCH_PAPERS_REQUEST,
  FETCH_PAPERS_SUCCESS,
  FETCH_PAPERS_FAILURE,
  FETCH_PAPER_SUMMARY_REQUEST,
  FETCH_PAPER_SUMMARY_SUCCESS,
  FETCH_PAPER_SUMMARY_FAILURE,
  FETCH_SEM_SUMMARY_REQUEST,
  FETCH_SEM_SUMMARY_SUCCESS,
  FETCH_SEM_SUMMARY_FAILURE,
  FETCH_SUBJECTS_REQUEST,
  FETCH_SUBJECTS_SUCCESS,
  FETCH_SUBJECTS_FAILURE,
  FETCH_DEPARTMENT_REPORT_REQUEST,
  FETCH_DEPARTMENT_REPORT_SUCCESS,
  FETCH_DEPARTMENT_REPORT_FAILURE,
  CLEAR_DEPARTMENT_REPORT,
  FETCH_SESSION_LIST_REQUEST,
  FETCH_SESSION_LIST_SUCCESS,
  FETCH_SESSION_LIST_FAILURE,
  FETCH_PROGRAMMES_REQUEST,
  FETCH_PROGRAMMES_SUCCESS,
  FETCH_PROGRAMMES_FAILURE,
  FETCH_STUDENT_PAPER_SUMMARY_REQUEST,
  FETCH_STUDENT_PAPER_SUMMARY_SUCCESS,
  FETCH_STUDENT_PAPER_SUMMARY_FAILURE,
} from "../actions/attendanceActions";

const initialState = {
  attendance: [],
  papers: [],
  subjects: [],
  paperSummary: null,
  semesterSummary: null,
  studentPaperSummary: null,
  departmentReport: null,
  departmentPagination: {},
  sessionList: [],
  programmes: [],

  pagination: {
    currentPage: 1,
    totalPages: 1,
    totalRecords: 0,
    limit: 10,
  },

  loading: false,
  error: null,
};

const attendanceReducer = (state = initialState, action) => {
  switch (action.type) {
    /* ================= ATTENDANCE ================= */

    case FETCH_ATTENDANCE_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_ATTENDANCE_SUCCESS:
      return {
        ...state,
        loading: false,
        attendance: action.payload.attendance,
        pagination: action.payload.pagination,
      };

    case FETCH_ATTENDANCE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    /* ================= SUBJECTS ================= */

    case FETCH_SUBJECTS_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_SUBJECTS_SUCCESS:
      return {
        ...state,
        loading: false,
        subjects: action.payload,
      };

    case FETCH_SUBJECTS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    /* ================= PAPERS ================= */

    case FETCH_PAPERS_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_PAPERS_SUCCESS:
      return {
        ...state,
        loading: false,
        papers: action.payload,
      };

    case FETCH_PAPERS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    /* ================= PAPER SUMMARY ================= */

    case FETCH_PAPER_SUMMARY_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_PAPER_SUMMARY_SUCCESS:
      return {
        ...state,
        loading: false,
        paperSummary: action.payload,
      };

    case FETCH_PAPER_SUMMARY_FAILURE:
      return { ...state, loading: false, error: action.payload };

    /* ================= SEMESTER SUMMARY ================= */

    case FETCH_SEM_SUMMARY_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_SEM_SUMMARY_SUCCESS:
      return {
        ...state,
        loading: false,
        semesterSummary: action.payload,
      };

    case FETCH_SEM_SUMMARY_FAILURE:
      return { ...state, loading: false, error: action.payload };

    /* ================= STUDENT PAPER SUMMARY (for modal) ================= */
    case FETCH_STUDENT_PAPER_SUMMARY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        studentPaperSummary: null,
      };

    case FETCH_STUDENT_PAPER_SUMMARY_SUCCESS:
      return {
        ...state,
        loading: false,
        studentPaperSummary: action.payload,
        error: null,
      };

    case FETCH_STUDENT_PAPER_SUMMARY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        studentPaperSummary: null,
      };

    /* ================= DEPARTMENT SUMMARY ================= */
    /* ================= DEPARTMENT REPORT ================= */

    case FETCH_DEPARTMENT_REPORT_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_DEPARTMENT_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        departmentReport: action.payload.data,
        departmentPagination: action.payload.pagination,
        error: null,
      };

    case FETCH_DEPARTMENT_REPORT_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case CLEAR_DEPARTMENT_REPORT:
      return {
        ...state,
        departmentReport: null,
        departmentPagination: {},
      };

    /* ================= SESSION LIST ================= */

    case FETCH_SESSION_LIST_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_SESSION_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        sessionList: action.payload,
        error: null,
      };

    case FETCH_SESSION_LIST_FAILURE:
      return { ...state, loading: false, error: action.payload };

    /* ================= PROGRAMMES ================= */

    case FETCH_PROGRAMMES_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_PROGRAMMES_SUCCESS:
      return {
        ...state,
        loading: false,
        programmes: action.payload,
        error: null,
      };

    case FETCH_PROGRAMMES_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default attendanceReducer;
